"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  margin-top: -", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AudioOverlay = void 0;

var react_1 = __importDefault(require("react"));

var icons_1 = require("../../icons");

var isNative_1 = require("../isNative");

var styled_1 = require("../styled");

var theme_1 = require("../theme");

function AudioOverlay(_ref) {
  var isCompact = _ref.isCompact;
  var theme = (0, theme_1.useTheme)();
  return react_1.default.createElement(Container, null, isCompact ? null : react_1.default.createElement(StyledMic, {
    width: (0, theme_1.getSize)(theme, '@size-xxl'),
    height: (0, theme_1.getSize)(theme, '@size-xxl'),
    color: (0, theme_1.getColor)(theme, '@gray-2')
  }));
}

exports.AudioOverlay = AudioOverlay;
var StyledMic = (0, styled_1.styled)(icons_1.MicSpeaking)(_templateObject(), isNative_1.isNative ? '' : "\n    max-width: 10vw;\n    max-height: 10vw;\n  ", function (props) {
  return (0, theme_1.getSize)(props.theme, '@size-l');
});
var Container = (0, styled_1.styledContainer)(_templateObject2(), function (props) {
  return (0, theme_1.getColor)(props.theme, '@gray-3');
});